import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Footer.css';

const Footer = () => {
  return (
    <footer className="bg-dark text-white mt-5 py-4">
      <Container>
        <Row>
          <Col md={4} className="mb-4 mb-md-0">
            <h5>Medicamentos Donados</h5>
            <p className="text-muted">
              Plataforma para conectar donantes de medicamentos con quienes los necesitan.
            </p>
          </Col>

          <Col md={4} className="mb-4 mb-md-0">
            <h5>Enlaces rápidos</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white">Inicio</Link>
              </li>
              <li>
                <Link to="/about" className="text-white">Acerca de</Link>
              </li>
              <li>
                <Link to="/login" className="text-white">Iniciar sesión</Link>
              </li>
              <li>
                <Link to="/register" className="text-white">Registrarse</Link>
              </li>
            </ul>
          </Col>

          <Col md={4}>
            <h5>Contacto</h5>
            <address className="text-muted">
              <p>Email: at@suriyaco.ar</p>
              <p>Teléfono: 3804 275678</p>
            </address>
          </Col>
        </Row>

        <hr className="bg-secondary" />

        <Row>
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Medicamentos Donados. Todos los derechos reservados son de Suriyaco Valley.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
